module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/005-ethiopia-b6d6285ea9472f42647b01e60ec9cded.svg";